import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { SearchResult } from "@dto/SearchResult";
import i18n from "../../i18n/i18n";
import { Place } from "@dto/Place";

export const searchApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    search: build.query<
      SearchResult[],
      {
        term: string;
      }
    >({
      query: (request) => {
        const url = `/search/names`;

        return {
          url: url,
          params: { term: request.term, locale: i18n.language },
        };
      },
      transformResponse: (responseData) => {
        return convertToCamel(responseData) as SearchResult[];
      },
      providesTags: (_search, _err, request) => [
        {
          type: "Search",
          term: request.term,
        },
      ],
    }),
    getFeaturedEntity: build.query<
      Place,
      {
        categoryIds: number[];
      }
    >({
      query: (request) => {
        const queryParams = [] as string[];
        if (request.categoryIds && request.categoryIds.length > 0) {
          request.categoryIds.forEach((id) => {
            queryParams.push(`category_ids[]=${encodeURIComponent(id)}`);
          });
        }

        const url = `/search/featured_entity?${queryParams.join("&")}`;
        return { url: url };
      },
      transformResponse: (responseData) => {
        return convertToCamel(responseData) as Place;
      },
      providesTags: (_search, _err, _request) => [
        {
          type: "Search",
          featured: true,
        },
      ],
    }),
  }),
});

export const { useSearchQuery, useGetFeaturedEntityQuery } = searchApi;

export const {
  endpoints: { search, getFeaturedEntity },
} = searchApi;
